import { StatusPill, type StatusTone } from '@hue/design-system';
import './public-portal.css';
import type { PortalAppointment } from '../lib/portal-api.js';
import { customerAppointmentStatuses } from './customer-appointment-labels.js';

const tones: Record<PortalAppointment['status'], StatusTone> = {
  SCHEDULED: 'warning',
  CONFIRMED: 'positive',
  CANCELLED: 'danger',
  COMPLETED: 'progress',
  NO_SHOW: 'neutral',
};

export function CustomerAppointmentStatus({
  appointment,
}: {
  appointment: Pick<PortalAppointment, 'status' | 'requiresConfirmation'>;
}) {
  const scheduled = appointment.status === 'SCHEDULED' && !appointment.requiresConfirmation;
  return (
    <StatusPill
      className="customer-appointment-status"
      tone={scheduled ? 'brand' : tones[appointment.status]}
    >
      {scheduled ? 'Agendado' : customerAppointmentStatuses[appointment.status]}
    </StatusPill>
  );
}
